var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAcceleration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.725,
    height: 16.907,
    viewBox: "0 0 19.725 16.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-speedometer",
    "data-name": "Icon ionic-ios-speedometer",
    d: "M12.112,4.5A9.859,9.859,0,0,0,4.729,20.9c.048.053.092.106.141.154a1.109,1.109,0,0,0,1.633,0,7.622,7.622,0,0,1,11.218,0,1.109,1.109,0,0,0,1.633,0L19.5,20.9A9.859,9.859,0,0,0,12.112,4.5ZM11.5,6.521a.616.616,0,0,1,1.233,0V8.106a.616.616,0,1,1-1.233,0ZM5.86,14.974H4.275a.616.616,0,0,1,0-1.233H5.86a.616.616,0,0,1,0,1.233Zm2.267-4.6h0a.622.622,0,0,1-.872,0L6.133,9.255a.622.622,0,0,1,0-.872h0a.622.622,0,0,1,.872,0L8.128,9.506A.617.617,0,0,1,8.128,10.373ZM15.2,11.892l-2.091,3.324a1.365,1.365,0,0,1-.308.308,1.326,1.326,0,0,1-1.541-2.157l3.324-2.091a.45.45,0,0,1,.515,0A.443.443,0,0,1,15.2,11.892Zm1.77-1.519a.622.622,0,0,1-.872,0h0a.622.622,0,0,1,0-.872L17.22,8.379a.622.622,0,0,1,.872,0h0a.622.622,0,0,1,0,.872Zm2.981,4.6H18.364a.616.616,0,0,1,0-1.233h1.585a.616.616,0,0,1,0,1.233Z",
    transform: "translate(-2.25 -4.5)",
    fill: "#2e117f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceleration);
export default __webpack_public_path__ + "static/media/acceleration.2df04ec581a572b4e7708192503303e4.svg";
export { ForwardRef as ReactComponent };